export class LogIn {

	email: String;
	hashPassword: String;
	applicationName: String;
	channelId: String;
	clientName: String;
	responseData: Object;
}